
import Vue from 'vue'
import JcdcBtn from '@/components/jcdc/JcdcBtn.vue'
import JcdcModal from '@/components/jcdc/JcdcModal.vue'
import JcdcTextarea from '@/components/jcdc/JcdcTextarea.vue'

export default Vue.extend({
  name: 'CommentModal',
  components: { JcdcBtn, JcdcModal, JcdcTextarea },
  props: {
    title: { type: String, default: '' },
    comment: { type: String, default: '' },
    edited: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    value: { type: Boolean, default: false },
  },
  data() {
    return {
      dialog: this.value,
      newComment: this.comment,
    }
  },
  methods: {
    saveComment() {
      this.dialog = false
      this.$emit('save', this.newComment)
    },
  },
})
